import { TooltipComponent } from '@clarke-energia/foton-v2';
import React from 'react';
import { twMerge } from 'tailwind-merge';

interface FormSectionRootProps {
  children: React.ReactNode;
  className?: string;
}

function FormSectionRoot({ children, className }: FormSectionRootProps) {
  return <div className={className}>{children}</div>;
}

interface FormSectionContainerProps {
  children: React.ReactNode;
  className?: string;
}

function FormSectionContainer({ children, className }: FormSectionContainerProps) {
  return <div className={twMerge('flex w-full', className)}>{children}</div>;
}

interface FormSectionHeaderProps {
  title: string;
  subtitle: string;
  className?: string;
  children?: React.ReactNode;
  tooltipContent?: string;
}

function FormSectionHeader({ title, subtitle, className, children, tooltipContent }: FormSectionHeaderProps) {
  return (
    <div className={twMerge('flex flex-col gap-2 w-1/3', className)}>
      <span className="flex gap-5">
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        {tooltipContent && (
          <TooltipComponent
            icon={{
              icon: 'InformationCircleIcon',
              solid: true,
            }}
            side="right"
            content={tooltipContent}
          />
        )}
      </span>
      <p className="text-sm text-gray-600 pr-10">{subtitle}</p>
      {children}
    </div>
  );
}

interface FormSectionFieldsProps {
  children: React.ReactNode;
  className?: string;
  gridColumn?: number;
}

function FormSectionFields({ children, className, gridColumn = 2 }: FormSectionFieldsProps) {
  const gridColsClass =
    {
      1: 'grid-cols-1',
      2: 'grid-cols-2',
      3: 'grid-cols-3',
      4: 'grid-cols-4',
      5: 'grid-cols-5',
      6: 'grid-cols-6',
    }[gridColumn] || 'grid-cols-2';

  return <div className={twMerge(`grid gap-6 ${gridColsClass}`, className)}>{children}</div>;
}

export const FormSection = {
  Root: FormSectionRoot,
  Container: FormSectionContainer,
  Header: FormSectionHeader,
  Fields: FormSectionFields,
};
